<template>
  <div class="main-wrapper" ref="wrapper">
    <el-container>
      <el-header height="50px" style="line-height: 50px">
        <el-form :model="form" :inline="true" size="small">
          <el-form-item label="年">
            <el-date-picker
              v-model="form.year"
              type="year"
              placeholder="选择年"
              value-format="yyyy">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="月">
            <el-date-picker
              v-model="form.month"
              type="month"
              placeholder="选择月"
              format="MM"
              value-format="MM">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="店铺">
            <el-select v-model="form.storeId" placeholder="请选择">
              <el-option
                v-for="item in authOptionsList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="float: right;">
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button type="warning" @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </el-header>
    </el-container>
    <el-container>
      <el-main>
        <div style="margin-bottom: 10px;">
          <el-button type="primary" size="mini" @click="dataImport">导入</el-button>
        </div>
        <el-table :data="tableData" border :height="tableHeight+'px'" v-loading="tableData === null" v-if="tableHeight">
          <el-table-column label="店铺简称" prop="salesShop"></el-table-column>
          <el-table-column label="年" prop="year"></el-table-column>
          <el-table-column label="月" prop="month"></el-table-column>
          <el-table-column label="日" prop="day"></el-table-column>
          <el-table-column label="目标（万元）" prop="aims"></el-table-column>
          <el-table-column label="更新日期" prop="updatedDate"></el-table-column>
        </el-table>
        <!-- pagination -->
        <div style="text-align: right; margin-top: 10px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total">
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
// import mixin from '@/views/preSalePlan/utils/mixin.js'
import * as Global from '@/utils/Global.js'
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [pagePathMixin],
  data() {
    return {
      form: {},
      tableData: null,
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageNum: 1,
        pageSize: 30,
        total: 0
      },
      tableHeight: 0,
      authOptions: []
    }
  },
  computed: {
    authOptionsList() {
      return [
        { id: '', name: '全部' },
        ...this.authOptions
      ]
    }
  },
  mounted() {
    this.tableHeight = this.$refs['wrapper'].offsetHeight - 176;
    this.$set(this.form, 'year', String(new Date().getFullYear()));
    let month = String(new Date().getMonth()+1);
    this.$set(this.form, 'month', month > 9 ? month : '0'+month);
    this.$set(this.form, 'storeId', '');
    this.dianpu()
    this.init();
  },
  methods: {
    dianpu() {
      this.$q.preSalePlan.planGetStoreNameOptions()
          .then(res=>{
            if(res.success && res.data && res.data.storeNameOptions.length) {
              this.authOptions = res.data.storeNameOptions
            }
          });
    },
    init() {
      let data = {
        filterData: {
          ...this.form
        },
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize
      };
      this.$q.preSalePlan.salesTarget({data})
      .then(res=>{
        if(res.data && res.data.records) {
          this.tableData = res.data.records;
          this.paginationOpt.total = res.data.total;
        }else{
          this.tableData = [];
          this.paginationOpt.total = 0;
        }
      })
    },
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    search() {
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    reset() {
      this.paginationOpt.pageNum = 1;
      this.form = {};
      this.$nextTick(_=>{
        this.init();
      })
    },
    dataImport() {
      this.openSubPage({
        path: '/dataImport/salesTarget',
        query: {
          // fileType: Global.FILE_TYPE['销售目标'],
          fileName: '销售目标.xlsx',
          appCode: 'ec-pc-new'
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .main-wrapper
    height calc(100vh - 85px)
    padding 10px
    box-sizing border-box

  >>> .el-container
    background #ffffff

  >>> .el-main
    padding 10px

  >>> .el-container+.el-container
    margin-top 10px

  >>>.el-date-editor.el-input, >>>.el-date-editor.el-input__inner
    width 140px

  >>> .el-form-item--small.el-form-item
    margin-bottom 0px

  >>> .el-form-item--small .el-form-item__content
    line-height 50px
</style>